import { Model } from "./model";

export class CreditCard extends Model {

  constructor(
    public id?: number,
    public holder: string = null,
    public cardNumber: string = null,
    public cardType: string = null,
    public expiryMonth: string = null,
    public expiryYear: string = null,
    public cvv: string = null,
  ) { super(); }

  static clone(obj: any) {
    return {
      ...new this(),
      ...obj
    }
  }

  serializeForRails() {
    return {
      card_number: this.cardNumber,
      card_holder: this.holder,
      card_expiry: `${this.expiryMonth}/${this.expiryYear}`,
      cvv: this.cvv,
    }
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/credit-card.ts